import { render } from "./Theme.vue?vue&type=template&id=737cf69d"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import "./Theme.vue?vue&type=style&index=0&id=737cf69d&lang=scss"
script.render = render

export default script